import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { INVALID_SIGNIN, UNAUTHORIZED_MSG } from '../constants/errors'
import useIdentity from '../hooks/useIdentity'

interface Props {
  allowedRoles: string[]
}

/**
 * Middleware to permission the wrapped routes, or redirect the user to other locations
 */
const PermissionedRoute = (props: Props) => {
  const { allowedRoles } = props
  const location = useLocation()
  const { identity } = useIdentity()

  if (!identity) {
    return (
      <Navigate
        to='login'
        state={{ from: location, reason: INVALID_SIGNIN }}
        replace
      />
    )
  }

  const isAuth = allowedRoles.includes(identity.role)

  if (isAuth) {
    return <Outlet />
  } else {
    return (
      <Navigate
        to='/'
        state={{ from: location, reason: UNAUTHORIZED_MSG }}
        replace
      />
    )
  }
}

export default PermissionedRoute
